import { Text } from "@mantine/core";
import { useModals } from "@mantine/modals";
import { useNavigate } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import { Check } from "tabler-icons-react";
import useMutateCustomerData from "./useMutateCustomerData";
import { deleteCustomer } from "../../api/customers";

export default function useDeleteCustomer(navigateAway: boolean = false) {
  const modals = useModals();
  const navigate = useNavigate();

  const onSuccess = () => {
    showNotification({
      title: "Customer deleted",
      icon: <Check />,
      message: `The customer has been deleted!`,
    });

    navigateAway && navigate(`/customers`);
  };

  const onError = (error: string) => {
    showNotification({
      title: `Something went wrong`,
      message: `An error occurred while deleting the customer(s). ${error}`,
      color: "red",
    });
  };

  const { mutate } = useMutateCustomerData(deleteCustomer, onSuccess, onError);

  const openModal = (ids: string[], onConfirm?: () => void) =>
    modals.openConfirmModal({
      centered: true,
      title: "Are you sure?",
      children: (
        <Text
          size="sm"
          sx={(theme) => ({
            color:
              theme.colorScheme === "dark"
                ? theme.colors.dark[0]
                : theme.colors["custom-gray"][0],
          })}
        >
          This action cannot be undone. Are you sure you want to delete{" "}
          {ids.length > 1 ? `these ${ids.length} customers` : "this customer"}?
        </Text>
      ),
      labels: { confirm: "Delete", cancel: "Cancel" },
      confirmProps: { color: "custom-red" },
      onCancel: () => {},
      onConfirm: async () => {
        await mutate(ids);
        onConfirm?.();
      },
    });

  return {
    openModal,
  };
}
